import React from "react";
import { Col, Select, Typography } from "antd";
import { any, array, bool, func, number, string } from "prop-types";
import { INPUT_SIZE } from "../../common/ThemeConstants";
import "./FormSelect.css";

const { Text } = Typography;

/**
 * Multi-select component using Ant Design Select
 */
const FormMultiSelect = (props) => {
  const {
    value = [],
    allowClear = true,
    required,
    disabled,
    colSpan,
    listItem,
    idName = "",
    valueName = "",
    size = INPUT_SIZE,
    label,
    name,
    placeholder,
    onChange,
    tabIndex,
    defaultValue = [],
    width = "100%",
    className = "rounded-md",
    showSearch,
    visible = true
  } = props;

   const normalizeValues = (val) => {
    if (!val) return [];
    if (Array.isArray(val) && typeof val[0] === "object") {
      return val.map((item) => item[idName]);
    }
    return val;
  };

  const handleSelectChange = (selectedValues) => {
    // onChange({
    //   name,
    //   value: selectedValues
    // });
    if (onChange) {
      onChange(selectedValues);
    }
  };

  const options =
    listItem?.sort((a, b) => a[valueName]?.localeCompare(b[valueName]))?.map(
      (item) => ({
        label: item[valueName],
        value: item[idName]
      })
    ) || [];

    if (!visible) return null;
    
  return (
    <Col span={colSpan} className={`selectInput ${className}`}>
      <Text>
        {label}
        {required && (
          <span style={{ color: "red", fontSize: 18, lineHeight: "14px" }}>
            *
          </span>
        )}
      </Text>

      <Select
        mode="multiple"
        allowClear={allowClear}
        style={{ width }}
        placeholder={placeholder || `Select ${label}`}
        size={size}
        defaultValue={normalizeValues(defaultValue)}
        value={normalizeValues(value)}
        onChange={handleSelectChange}
        options={options}
        disabled={disabled}
        tabIndex={tabIndex}
        showSearch
        filterOption={(input, option) =>
    option.label.toLowerCase().includes(input.toLowerCase())
  }
      />
    </Col>
  );
};

FormMultiSelect.propTypes = {
  defaultValue: any,
  value: any,
  allowClear: bool,
  required: bool,
  disabled: bool,
  loading: bool,
  colSpan: number,
  idName: string.isRequired,
  valueName: string.isRequired,
  listItem: array.isRequired,
  size: string,
  label: string,
  onChange: func,
  name: string,
  status: string,
  placeholder: string,
  tabIndex: number,
  width: string
};

export default FormMultiSelect;
